// extracted by mini-css-extract-plugin
export default {"divida-consolidada-liquida":"DividaConsolidadaLiquida_divida-consolidada-liquida__8IWTZ"};